/**
 * Constants used for Sentry configuration and PII scrubbing
 */

// Environments where Sentry should NOT be initialized
export const EXCLUDED_SENTRY_ENVIRONMENTS = ['development', 'local'];

// Production environment identifiers (for enabling performance monitoring)
export const PRODUCTION_ENVIRONMENTS = ['production', 'prod'];

// Regex pattern for detecting email addresses
export const EMAIL_REGEX = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;

// Pattern for detecting sensitive data in console breadcrumbs
export const SENSITIVE_PATTERNS = /email|uid|token|password|access_token|refresh_token|id_token|apikey|api_key|secret|credential/i;

// Query parameters that should be stripped from URLs in breadcrumbs
export const SENSITIVE_URL_PARAMS = [
  'code',
  'state',
  'session_state',
  'key',
  'token',
  'access_token',
  'refresh_token',
  'id_token',
  'apikey',
  'api_key',
  'secret',
  'password',
  'code_verifier',
  'iss',
];

// Transient network / browser errors that should NOT be sent to Sentry.
// These are caused by user connectivity issues, not application bugs.
export const IGNORED_ERROR_PATTERNS = [
  /Failed to update a ServiceWorker/i,
  /Failed to fetch/i,
  /NetworkError when attempting to fetch resource/i,
  /Load failed/i,
  /net::ERR_/i,
  /WebSocket closed with status code: 1006/i,
  /Failed to complete negotiation with the server/i,
  /Failed to start the connection/i,
  /An unknown error occurred when fetching the script/i,
  /The network connection was lost/i,
  /Network request failed/i,
];

// Keys that should be filtered from request data and extra context
export const SENSITIVE_KEYS = [
  'password',
  'token',
  'access_token',
  'refresh_token',
  'id_token',
  'email',
  'apiKey',
  'api_key',
  'secret',
  'uid'
];
